import { DELIVERY_DARE_FORM_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'

export default recordId => pushRouteClient({
	routeId: DELIVERY_DARE_FORM_ROUTE_ID,
	routeParams: { recordId },
})
